module.exports = __webpack_public_path__ + "static/media/principalesyotros_checked.7626b486.svg";